import React from 'react';
import type { PendingAssociateProfilePlacement } from 'src/services/associateProfile/types';
import PlacementInfo from './placementInfo';
import PlacementCardLayout from './placementCardLayout';

interface PendingPlacementCardProps {
  placement: PendingAssociateProfilePlacement;
}

const PendingPlacementCard = ({ placement }: PendingPlacementCardProps) => (
  <PlacementCardLayout placement={placement}>
    <PlacementInfo label="Injury" value={placement.injury} />
    <PlacementInfo label="Start Date" value={new Date(placement.startAtDate).toLocaleDateString()} />
    <PlacementInfo label="End Date" value={new Date(placement.endAtDate).toLocaleDateString()} />
    <PlacementInfo label="Time In Pending" value={placement.timeInPending} />
    <PlacementInfo label="Job(s)" value={placement.numSelectedJobs} />
  </PlacementCardLayout>
);

export default PendingPlacementCard;
